export default {
  name: 'qrcode',
  type: 'layout',
  active: false,
  data: {
    type: 'page',
    url: {},
    pageId: '',
    target: false
  }
}
